export const Sprout = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 15H15V13C15 7.47715 19.4772 3 25 3H27V5C27 10.5228 22.5228 15 17 15Z" stroke="currentColor" stroke-width="2"/>
<path d="M13 15H15V13C15 9.68629 12.3137 7 9 7H7V9C7 12.3137 9.68629 15 13 15Z" stroke="currentColor" stroke-width="2"/>
<path d="M15 26V14.6667" stroke="currentColor" stroke-width="2"/>
<path d="M22.5 30C21.6667 28.6667 19.0035 26.0155 15.2647 26.0155C11.7074 26.0155 9.72216 27.5472 8.62891 28.6406" stroke="currentColor" stroke-width="2"/>
</svg>`;
